import withDraft from '@/utils/draftHelper';
import { states } from '@/constants/lifecycle';
import { responseError } from '@/utils/errors';
import {
  assignValue,
  findSelectedInCategory,
  mapItemOrderByValues,
  mapResults,
} from '@/utils/resultsHelper';
import actions from '../constants';
import { collectionsResult, collectionStateToLoad, findCollections } from './state';

const closeCollections = withDraft((draft, action) => {
  draft.collections[action.category] = collectionStateToLoad({ collections: draft }).collections[action.category];
});

const fetchOrRefreshCollections = withDraft((draft, action) => {
  const item = findCollections(draft, action);
  item.readStatus = states.PENDING;
  item.readErrors = [];
});

const showCollectionsError = withDraft((draft, action) => {
  const item = findCollections(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const showCollectionsResults = withDraft((draft, action) => {
  const item = findCollections(draft, action);
  item.readStatus = states.SUCCESS;
  item.readErrors = [];
  item.results = action.append
    ? mapResults(item.results, action, collectionsResult)
    : mapResults([], action, collectionsResult);
  item.pageSize = action.pageSize;
  item.count = action.resultsCount;
  item.currentPage = action.currentPage;
  item.totalPages = action.totalPages;
});

const showDeleteCollections = withDraft((draft, action) => {
  draft.deleteCollectionOpen = true;
  draft.collections.deletion.results = findSelectedInCategory(draft.collections, action.category);
});

const toggleCollectionsColumnOrderBy = withDraft((draft, { category, orderByColumn }) => {
  const item = findCollections(draft, { category });
  item.readStatus = states.PENDING;
  item.readErrors = [];
  item.orderBy = mapItemOrderByValues(item.orderBy, orderByColumn, item.singleSorting);
});

const toggleCollectionsPresentation = withDraft((draft, action) => {
  const item = findCollections(draft, action);
  item.display = action.display;
  item.readStatus = states.PENDING;
  item.readErrors = [];
  item.results = [];
  item.count = 0;
  item.currentPage = 1;
  item.totalPages = 0;
});

const toggleCollectionsSelected = withDraft((draft, action) => {
  const item = findCollections(draft, action);
  item.results.forEach((result) => {
    assignValue(result, 'selected', action.selected);
  });
});

const toggleCollectionsSingleSorting = withDraft((draft, action) => {
  const item = findCollections(draft, action);
  item.readStatus = states.PENDING;
  item.readErrors = [];
  item.singleSorting = !item.singleSorting;
  item.orderBy = [item.orderBy[0]];
});

const updateCollectionsFilter = withDraft((draft, action) => {
  const item = findCollections(draft, action);
  item.filter = action.value;
});

export default {
  [actions.CLOSE_COLLECTIONS]: closeCollections,
  [actions.FETCH_COLLECTIONS]: fetchOrRefreshCollections,
  [actions.REFRESH_COLLECTIONS]: fetchOrRefreshCollections,
  [actions.SHOW_COLLECTIONS_ERROR]: showCollectionsError,
  [actions.SHOW_COLLECTIONS_RESULTS]: showCollectionsResults,
  [actions.SHOW_DELETE_COLLECTIONS]: showDeleteCollections,
  [actions.TOGGLE_COLLECTIONS_COLUMN_ORDER_BY]: toggleCollectionsColumnOrderBy,
  [actions.TOGGLE_COLLECTIONS_PRESENTATION]: toggleCollectionsPresentation,
  [actions.TOGGLE_COLLECTIONS_SELECTED]: toggleCollectionsSelected,
  [actions.TOGGLE_COLLECTIONS_SINGLE_SORTING]: toggleCollectionsSingleSorting,
  [actions.UPDATE_COLLECTIONS_FILTER]: updateCollectionsFilter,
};
